import { i18nToFixed } from "@common/src/utils/tools";

/* eslint-disable */
(Number.prototype as any).i18nToFixed = i18nToFixed;
